<script lang="ts">
    import { spaLink } from "../actions"
    import MedialibFile from "./MedialibFile.svelte"

    export let links: BlockLink[]
</script>

{#each links || [] as link}
    {#if link.url || !link.file}
        <a use:spaLink href="{link.url}" class="cta btn-{link.style} {link.style}" target="{link.target || undefined}"
            >{link.text}</a
        >
    {:else}
        <MedialibFile id="{link.file}" let:src>
            <a href="{src}" class="cta btn-{link.style} {link.style}" target="{link.target || undefined}">{link.text}</a
            >
        </MedialibFile>
    {/if}
{/each}
